import React, { useState } from "react";
import { Link } from "react-router-dom";

export default function Navbar({ onSignupClick, onLoginClick }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="fixed top-0 left-0 w-full px-6 py-4 bg-gray-900 border-b border-gray-700 shadow z-50">
      <div className="flex justify-between items-center">
        {/* Brand with SVG Logo */}
        <Link to="/" className="flex items-center space-x-2">
          {/* SVG Logo */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 64 64"
            className="h-10 w-10"
            fill="currentColor"
          >
            <circle
              cx="32"
              cy="32"
              r="30"
              className="stroke-indigo-600"
              strokeWidth="4"
              fill="white"
            />
            <text
              x="32"
              y="38"
              textAnchor="middle"
              fontSize="20"
              fontWeight="bold"
              fill="currentColor"
            >
              ₿
            </text>
          </svg>

          <span className="text-2xl font-bold text-white hover:text-indigo-400">
            OnChainHub
          </span>
        </Link>

        {/* Desktop Menu */}
        <ul className="hidden md:flex items-center space-x-6 font-medium text-white">
          <li>
            <Link to="/about" className="hover:text-indigo-400">
              About Us
            </Link>
          </li>
          <li>
            <Link to="/features" className="hover:text-indigo-400">
              Features
            </Link>
          </li>
          <li>
            <button onClick={onLoginClick} className="hover:text-indigo-400">
              Login
            </button>
          </li>
          <li>
            <button
              onClick={onSignupClick}
              className="px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700 transition"
            >
              Sign Up
            </button>
          </li>
        </ul>

        {/* Hamburger Icon */}
        <button
          className="md:hidden text-white focus:outline-none"
          onClick={() => setIsOpen(!isOpen)}
        >
          <svg
            className="w-8 h-8"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            {isOpen ? (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            ) : (
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 12h16M4 18h16"
              />
            )}
          </svg>
        </button>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden mt-4 flex flex-col space-y-3 font-medium text-white">
          <Link to="/about" className="hover:text-indigo-600">
            About Us
          </Link>
          <Link to="/features" className="hover:text-indigo-600">
            Features
          </Link>

          <button
            onClick={onLoginClick}
            className="px-4 py-2 border border-indigo-600 text-white rounded hover:bg-indigo-50 transition"
          >
            Login
          </button>

          <button
            onClick={onSignupClick}
            className="px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700 transition"
          >
            Sign Up
          </button>
        </div>
      )}
    </nav>
  );
}
